import React from "react";
import pre from "../Assets/pre.svg";

function Pre(props) {
    return (
        <div id={props.load ? "preloader" : "preloader-none"}>
            {props.load && (
                <img
                    src={pre}
                    className="img-fluid logo-pre" // La classe "logo" applique l'animation
                    alt="preloader"
                    style={{
                        width: "150px"
                    }}
                />
            )}
        </div>
    );
}

export default Pre;
